"use client";

import { Github, Linkedin, Mail, Phone, MessageCircle, Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
function FooterMenuList() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        <li className="h-4 w-24 bg-muted animate-pulse rounded-md" />
        <li className="h-4 w-20 bg-muted animate-pulse rounded-md" />
        <li className="h-4 w-28 bg-muted animate-pulse rounded-md" />
        <li className="h-4 w-16 bg-muted animate-pulse rounded-md" />
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="text-sm md:text-base text-foreground hover:text-secondary transition-colors font-default w-full md:w-auto inline-block">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const services = [{
  label: "Holiday Packages",
  href: "/HomePage"
}, {
  label: "Flight Bookings",
  href: "/HomePage"
}, {
  label: "Travel Insurance",
  href: "/HomePage"
}, {
  label: "Group Travel",
  href: "/HomePage"
}];
const contactLinks = [{
  label: "bookings@marga-travel.com",
  href: "mailto:bookings@marga-travel.com",
  icon: Mail
}, {
  label: "+27 10 019\xA00826",
  href: "tel:+27100190826",
  icon: Phone
}, {
  label: "WhatsApp Us",
  href: "https://wa.me/message/6FJ3ZTYI5VXRP1",
  icon: MessageCircle
}, {
  label: "@marga.travel",
  href: "https://www.instagram.com/marga.travel",
  icon: Instagram
}];
const legalLinks = [{
  label: "Privacy Policy",
  href: "#"
}, {
  label: "Terms of Use",
  href: "#"
}, {
  label: "Legal Notice",
  href: "#"
}];
export default function Connect() {
  return <section data-section-id="4794" id="connect-with-us" className="dark bg-background text-foreground border-t border-border pt-32 pb-12 px-6 md:px-12 relative overflow-hidden">
      {}
      <div className="absolute top-6 left-6 font-mono text-[10px] text-muted-foreground tracking-widest">MARGA TRAVEL (PTY) LTD</div>
      

      <div className="max-w-7xl mx-auto">
        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4 md:gap-6">
          {}
          <div className="lg:col-span-4 space-y-6">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-8 w-auto" />
            </Link>

            <p className="text-lg text-muted-foreground font-default leading-relaxed max-w-sm">
              Curating extraordinary journeys across the globe with expert precision.
            </p>

            <div className="space-y-2 pt-2">
              <div className="font-mono text-xs text-secondary tracking-wider"></div>
              <p className="text-[13px] text-muted-foreground font-default leading-relaxed">Johannesburg, SA<br />Sandton, 2196</p>
            </div>

            <div className="pt-2 space-y-1">
              <div className="font-mono text-[10px] text-muted-foreground tracking-widest uppercase">WORKING Hours</div>
              <div className="font-mono text-xs text-foreground">MON-FRI / 09:00 — 17:00</div>
            </div>
          </div>

          {}
          <div className="lg:col-span-3 lg:col-start-5">
            <div className="flex items-center gap-2 mb-6">
              <div className="h-px w-4 bg-secondary" />
              <h3 className="font-default text-xs font-semibold tracking-widest uppercase text-foreground">
                Navigation
              </h3>
            </div>
            <MenuProvider menu_id="header-menu">
              <FooterMenuList />
            </MenuProvider>
          </div>

          {}
          <div className="lg:col-span-3">
            <div className="flex items-center gap-2 mb-6">
              <div className="h-px w-4 bg-secondary" />
              <h3 className="font-default text-xs font-semibold tracking-widest uppercase text-foreground">
                Services
              </h3>
            </div>
            <ul className="space-y-3">
              {services.map((service, i) => <li data-index={i} key={service.label}>
                  <Link to={service.href} className="text-sm md:text-base text-foreground hover:text-secondary transition-colors font-default inline-flex items-center gap-1.5 group w-full md:w-auto">
                    <span className="text-secondary opacity-0 group-hover:opacity-100 transition-opacity font-mono text-xs">
                      {">"}
                    </span>
                    {service.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <div className="h-px w-4 bg-secondary" />
              <h3 className="font-default text-xs font-semibold tracking-widest uppercase text-foreground">
                Connect
              </h3>
            </div>
            <ul className="space-y-3">
              {contactLinks.map((link, i) => <li data-index={i} key={link.label}>
                  <Link to={link.href} className="text-sm md:text-base text-foreground hover:text-secondary transition-colors font-mono inline-flex items-center gap-1.5 break-all w-full md:w-auto">
                    <link.icon className="h-4 w-4 shrink-0" />
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {}
        <div className="mt-24 md:mt-32 relative">
          
          <div aria-hidden="true" className="font-default text-center leading-none tracking-tighter select-none !text-[rgba(30,59,138,1)] rounded-tl-[0px] rounded-tr-[0px] rounded-br-[0px] rounded-bl-[0px] !font-thin !text-6xl" style={{
          fontSize: "clamp(5rem, 22vw, 18rem)",
          WebkitTextStroke: "1px var(--secondary)",
          color: "transparent"
        }}>MGTRAVEL</div>
        </div>

        {}
        <div className="relative mt-8 mb-8">
          <Separator className="bg-border" />
          <div className="absolute inset-0 flex justify-between items-center pointer-events-none">
            {Array.from({
            length: 24
          }).map((_, i) => <div data-index={i} key={i} className="h-2 w-px bg-border" style={{
            marginTop: "-4px"
          }} />)}
          </div>
        </div>

        {}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 pt-4">
          <div className="font-mono text-xs text-muted-foreground tracking-wider !w-[289.421875px]">© 2026 MARGA TRAVEL / ALL RIGHTS RESERVED</div>

          <div className="flex items-center gap-2.5">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-secondary opacity-75" />
              <span className="relative inline-flex rounded-lg h-2 w-2 bg-primary" />
            </span>
            <span className="font-mono text-xs text-foreground tracking-wider">
              BOOKING ENGINE ONLINE &mdash; READY TO TRAVEL
            </span>
          </div>

          <ul className="flex items-center gap-5">
            {legalLinks.map((link, i) => <li data-index={i} key={link.label}>
                <Link to={link.href} className="font-mono text-[10px] md:text-xs text-muted-foreground hover:text-secondary transition-colors tracking-wider">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </div>

        {}
        <div className="flex justify-end mt-10">
          <span className="font-mono text-[10px] text-muted-foreground tracking-widest opacity-60">6v.2026.06.03</span>
        </div>
      </div>
    </section>;
}